import Vue from 'vue'
import Vuex from 'vuex'
import news from '@/store/news'
import user from '@/store/user'
import duty from '@/store/duty'
import admin from '@/store/admin'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    admin,
    news,
    user,
    duty
  }
})
